const INVESTMENT_DECISION_LIST = Object.freeze({
  ADVISOR_ONLY: {
    decisionStatement: 'I like to have investment professionals do it for me',
    code: 'ADVISOR_ONLY',
  },
  TOGETHER_WITH_ADVISOR: {
    decisionStatement:
      'I like to work with my advisor and select investments together',
    code: 'TOGETHER_WITH_ADVISOR',
  },
  MYSELF_ONLY: {
    decisionStatement: 'I like to make investment decisions myself',
    code: 'MYSELF_ONLY',
  },
  IT_DEPENDS: {
    decisionStatement: 'It depends on the type or purpose of my account',
    code: 'IT_DEPENDS',
  },
  UNSURE: {
    decisionStatement: 'I am unsure about this',
    code: 'UNSURE',
  },
});

export default INVESTMENT_DECISION_LIST;
